import React from 'react';

export const EmptySeating = () => (
  <svg
    width="207"
    height="112"
    viewBox="0 0 207 112"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5 0C20.8015 10.9184 29.5816 19.6985 40.5 20C29.5816 20.3015 20.8015 29.0816 20.5 40C20.1985 29.0816 11.4184 20.3015 0.5 20C11.4184 19.6985 20.1985 10.9184 20.5 0Z"
      fill="#262626"
    />
    <path
      d="M174.5 4C174.621 8.36735 178.133 11.8794 182.5 12C178.133 12.1206 174.621 15.6326 174.5 20C174.379 15.6326 170.867 12.1206 166.5 12C170.867 11.8794 174.379 8.36735 174.5 4Z"
      fill="#262626"
    />
    <path
      d="M198.5 61C198.621 65.3674 202.133 68.8794 206.5 69C202.133 69.1206 198.621 72.6326 198.5 77C198.379 72.6326 194.867 69.1206 190.5 69C194.867 68.8794 198.379 65.3674 198.5 61Z"
      fill="#262626"
    />
    <path
      d="M40.8434 69.411C42.6285 66.7334 45.6337 65.125 48.8518 65.125H76.8917C80.2447 65.125 83.3561 66.87 85.1045 69.731L92.8314 82.375H32.2007L40.8434 69.411Z"
      fill="white"
      stroke="black"
      strokeWidth="0.75"
    />
    <path
      d="M31.875 83.4167C31.875 82.7033 32.4533 82.125 33.1667 82.125H91.8333C92.5467 82.125 93.125 82.7033 93.125 83.4167C93.125 87.8119 89.5619 91.375 85.1667 91.375H39.8333C35.4381 91.375 31.875 87.8119 31.875 83.4167Z"
      fill="white"
      stroke="black"
      strokeWidth="0.75"
    />
    <path
      d="M42.875 30.5C42.875 25.1843 47.1843 20.875 52.5 20.875H71.5C76.8157 20.875 81.125 25.1843 81.125 30.5V60.5C81.125 63.0543 79.0543 65.125 76.5 65.125H47.5C44.9457 65.125 42.875 63.0543 42.875 60.5V30.5Z"
      fill="white"
      stroke="black"
      strokeWidth="0.75"
    />
    <path
      d="M124.843 69.411C126.628 66.7334 129.634 65.125 132.852 65.125H160.892C164.245 65.125 167.356 66.87 169.104 69.731L176.831 82.375H116.201L124.843 69.411Z"
      fill="white"
      stroke="black"
      strokeWidth="0.75"
    />
    <path
      d="M115.875 83.4167C115.875 82.7033 116.453 82.125 117.167 82.125H175.833C176.547 82.125 177.125 82.7033 177.125 83.4167C177.125 87.8119 173.562 91.375 169.167 91.375H123.833C119.438 91.375 115.875 87.8119 115.875 83.4167Z"
      fill="white"
      stroke="black"
      strokeWidth="0.75"
    />
    <path
      d="M126.875 30.5C126.875 25.1843 131.184 20.875 136.5 20.875H155.5C160.816 20.875 165.125 25.1843 165.125 30.5V60.5C165.125 63.0543 163.054 65.125 160.5 65.125H131.5C128.946 65.125 126.875 63.0543 126.875 60.5V30.5Z"
      fill="white"
      stroke="black"
      strokeWidth="0.75"
    />
    <path
      d="M82.8434 89.411C84.6285 86.7334 87.6337 85.125 90.8518 85.125H118.892C122.245 85.125 125.356 86.87 127.104 89.731L134.831 102.375H74.2007L82.8434 89.411Z"
      fill="white"
      stroke="black"
      strokeWidth="0.75"
    />
    <path
      d="M73.875 103.417C73.875 102.703 74.4533 102.125 75.1667 102.125H133.833C134.547 102.125 135.125 102.703 135.125 103.417C135.125 107.812 131.562 111.375 127.167 111.375H81.8333C77.4381 111.375 73.875 107.812 73.875 103.417Z"
      fill="white"
      stroke="black"
      strokeWidth="0.75"
    />
    <path
      d="M84.875 50.5C84.875 45.1843 89.1843 40.875 94.5 40.875H113.5C118.816 40.875 123.125 45.1843 123.125 50.5V80.5C123.125 83.0543 121.054 85.125 118.5 85.125H89.5C86.9457 85.125 84.875 83.0543 84.875 80.5V50.5Z"
      fill="white"
      stroke="black"
      strokeWidth="0.75"
    />
  </svg>
);
